import { render, staticRenderFns } from "./TheCategoriesDate.vue?vue&type=template&id=37f08597&"
import script from "./TheCategoriesDate.vue?vue&type=script&lang=js&"
export * from "./TheCategoriesDate.vue?vue&type=script&lang=js&"
import style0 from "./TheCategoriesDate.vue?vue&type=style&index=0&id=37f08597&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports